import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import CarouselSliderWrapper from "./Carousel.style"
import taj from "../../../assets/images/wkit/slide1.jpg"
import discount from "../../../assets/images/wkit/slide2.jpg"
import drive from "../../../assets/images/wkit/slide3.jpg"
import ithraa from "../../../assets/images/wkit/slide4.jpg"
import petromin from "../../../assets/images/wkit/slide5.jpg"
import play from "../../../assets/images/wkit/play.png"
import ithraaPrime from "../../../assets/images/wkit/slide6.jpg"
import Arrow from "../../../assets/images/wkit/rightArrow.svg";
import i18next from 'i18next';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';

const WelcomeCarousel = () => {
  const navigate = useNavigate()
  const currentLanguageCode = i18next.language || "en";
  const showRTL = currentLanguageCode === "ar";
  const { t } = useTranslation();

  const ReturnLearnMore = ({ link }) => {
    return (
      <p className="learnMore c-pointer" onClick={() => {
        // navigate(link, { target: "_blank" })
        window.open(link, "_blank")
      }}>
        <div>
          <img alt="Learn" className="learnMoreImg" src={Arrow} />
        </div>
        <p>{t("CAROUSEL.LEARN")}</p>
      </p>
    )
  }


  const carouselData = [
    {
      id: 0,
      img: ithraa,
      title: `${t("SuccessKit.Tawuniya")} ${t("SuccessKit.t-Ithraa")} `,
      content: t("SuccessKit.ithraa"),
      link: "/individuals/loyalty-program/ithra"
    },
    {
      id: 1,
      img: drive,
      title: `${t("SuccessKit.Tawuniya")} ${t("SuccessKit.t-Drive")} `,
      content: t("SuccessKit.drive"),
      link: "/individuals/products/motor/drive",
      video: true
    },
    // {
    //   id: 2,
    //   img: taj,
    //   title: `${t("SuccessKit.Tawuniya")} ${t("SuccessKit.t-TAJ")} `,
    //   content: t("SuccessKit.taj"),
    //   link: "https://tawuniya.com/"
    // },
    {
      id: 3,
      img: petromin,
      title: `${t("SuccessKit.Tawuniya")} ${t("SuccessKit.t-PETROMIN")} `,
      content: t("SuccessKit.petromin"),
      link: "/individuals/loyalty-program/tawuniya-petromin"

    },
    // {
    //   id: 4,
    //   img: discount,
    //   title: `${t("SuccessKit.Tawuniya")} ${t("SuccessKit.t-Discount")} `,
    //   content: t("SuccessKit.discount"),
    //   link: "https://tawuniya.com/"

    // },
    // {
    //   id: 5,
    //   img: ithraaPrime,
    //   title: `${t("SuccessKit.Tawuniya")} ${t("SuccessKit.t-Prime")} `,
    //   content: t("SuccessKit.ithraaPrime"),
    //   link: "/individuals/loyalty-program/ithra-prime"
    // },
  ]
  return (
    <CarouselSliderWrapper>
      <Carousel autoPlay={true} infiniteLoop={true} className={showRTL ? "main-div-rtl" : "main-div"}>
        {carouselData.map(card => {
          return (
            <div key={card.id}>
              <img className="carousel-img" alt="CarouselImage" src={card.img} />
              <div className="text-overlay">
                <p className="motorText">{card.title}</p>
                <p className="motorPara">{card.content}</p>
                {/* {card.video ? (
                  <div className="play-container">
                    <div className="play-slide">
                      <img className="play-icon" src={play} alt="Play" />
                    </div>
                  </div>
                ) : null}
                <ReturnLearnMore link={card.link} /> */}
              </div>
            </div>
          )
        })}
      </Carousel>
    </CarouselSliderWrapper>
  );
};
export default WelcomeCarousel;